import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

// Import our layout
import Layout from './components/Layout';

// Import our pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import DonatePage from './pages/DonatePage';
import ResourcesPage from './pages/ResourcesPage';
import UnderstandingTwitches from './pages/UnderstandingTwitches';
import ManagingStress from './pages/ManagingStress';
import LifestyleTips from './pages/LifestyleTips';
import ResearchPaperArchive from './pages/ResearchPaperArchive';
import BlogPage from './pages/BlogPage';

// Blog posts
import BlogPostBFSSymptoms from './pages/blogposts/BlogPost_BFSSymptoms'; 
import BlogPostBFSTreatment from './pages/blogposts/BlogPost_BFSTreatment';
import BlogPostBFSCure from './pages/blogposts/BlogPostBFSCure';
import BlogPostBFSvsALS from './pages/blogposts/BlogPost_BFSvsALS';
import BlogPostCalfTwitching from './pages/blogposts/BlogPostCalfTwitching';
import BlogPostEyeTwitching from './pages/blogposts/BlogPostEyeTwitching';
import BlogPostWhyEyeKeepsTwitching from './pages/blogposts/BlogPostWhyEyeKeepsTwitching';
import BlogPostEyeMuscleTwitch from './pages/blogposts/BlogPostEyeMuscleTwitch';
import BlogPostEyeSpasms from './pages/blogposts/BlogPostEyeSpasms';
import BlogPostIsEyeTwitchingDisease from './pages/blogposts/BlogPostIsEyeTwitchingDisease';
import BlogPostEyeballSpasms from './pages/blogposts/BlogPostEyeballSpasms';
import BlogPostEyeTwitchingAnxiety from './pages/blogposts/BlogPostEyeTwitchingAnxiety';
import BlogPostCaffeineEyeTwitching from './pages/blogposts/BlogPostCaffeineEyeTwitching';
import BlogPostLeftVsRightTwitching from './pages/blogposts/BlogPostLeftVsRightTwitching';
import BlogPostEyeTwitchingAtNight from './pages/blogposts/BlogPostEyeTwitchingAtNight';
import BlogPostVitaminDeficiency from './pages/blogposts/BlogPostVitaminDeficiency';
import BlogPostCalfTwitchingExercise from './pages/blogposts/BlogPostCalfTwitchingExercise';
import BlogPostCalfTwitchingNight from './pages/blogposts/BlogPostCalfTwitchingNight';
import BlogPostCalfTwitchingAnxiety from './pages/blogposts/BlogPostCalfTwitchingAnxiety';
import BlogPostCalfTwitchingALS from './pages/blogposts/BlogPostCalfTwitchingALS';
import BlogPostMuscleTwitchingNoWeakness from './pages/blogposts/BlogPostMuscleTwitchingNoWeakness';
import BlogPostCalfCrampsVsTwitching from './pages/blogposts/BlogPostCalfCrampsVsTwitching';
import BlogPostPersistentCalfTwitching from './pages/blogposts/BlogPostPersistentCalfTwitching';
import BlogPostLegTwitchingAtRest from './pages/blogposts/BlogPostLegTwitchingAtRest';
import BlogPostCalfTwitchingDehydration from './pages/blogposts/BlogPostCalfTwitchingDehydration';
import BlogPostCalfTwitchingMagnesium from './pages/blogposts/BlogPostCalfTwitchingMagnesium';
import BlogPostTongueTwitching from './pages/blogposts/BlogPostTongueTwitching';
import BlogPostBFSTimeline from './pages/blogposts/BlogPostBFSTimeline';
import BlogPostBodyTwitchingAllOver from './pages/blogposts/BlogPostBodyTwitchingAllOver';
import BlogPost_MuscleTwitchingInSleep from './pages/blogposts/BlogPost_MuscleTwitchingInSleep';
import BlogPost_InternalVibrations from './pages/blogposts/BlogPost_InternalVibrations';
import BlogPost_MuscleTwitchingAfterEating from './pages/blogposts/BlogPost_MuscleTwitchingAfterEating';
import BlogPost_MuscleTwitchingOneSpotVsAllOver from './pages/blogposts/BlogPost_MuscleTwitchingOneSpotVsAllOver';






// Component to track page views whenever the route changes
const TrackPageViews = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search });
  }, [location]);

  return null;
};

function App() {
  // Initialize GA only once on app load
  useEffect(() => {
    ReactGA.initialize('G-6DVXWSZC2L'); // ✅ Your GA4 Measurement ID
  }, []);

  return (
    <Router>
      <TrackPageViews />
      <Routes>
        {/* Wrap Layout around everything */}
        <Route path="/" element={<Layout />}>
          {/* index route => Home */}
          <Route index element={<HomePage />} />

          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="donate" element={<DonatePage />} />
          <Route path="resources" element={<ResourcesPage />} />
          <Route path="understanding-muscle-twitches" element={<UnderstandingTwitches />} />
          <Route path="managing-stress" element={<ManagingStress />} />
          <Route path="lifestyle-tips" element={<LifestyleTips />} />
          <Route path="research-archive" element={<ResearchPaperArchive />} />
          <Route path="blog" element={<BlogPage />} />

          {/* Blog post routes */}
          <Route
            path="blog/benign-fasciculation-syndrome-symptoms"
            element={<BlogPostBFSSymptoms />}
          />
          <Route
            path="blog/benign-fasciculation-syndrome-treatment"
            element={<BlogPostBFSTreatment />}
          />
          <Route
            path="blog/how-i-cured-benign-fasciculation-syndrome"
            element={<BlogPostBFSCure />}
          />
          <Route
            path="blog/benign-fasciculation-syndrome-vs-als"
            element={<BlogPostBFSvsALS />}
          />
          <Route 
            path="blog/calf-twitching-causes"
            element={<BlogPostCalfTwitching />}
          />
          <Route 
            path="blog/eye-twitching-causes"
            element={<BlogPostEyeTwitching />}
          />
          {/* 2. Add the new route for the persistent eye twitching post */}
          <Route 
            path="blog/why-eye-keeps-twitching"
            element={<BlogPostWhyEyeKeepsTwitching />}
          />
          <Route 
            path="blog/eye-muscle-twitch-triggers"
            element={<BlogPostEyeMuscleTwitch />}
          />
          <Route 
  path="blog/eye-spasms-stress-fatigue-screen-time"
  element={<BlogPostEyeSpasms />}
/>
<Route 
  path="blog/is-eye-twitching-a-disease"
  element={<BlogPostIsEyeTwitchingDisease />}
/>
<Route 
  path="blog/eyeball-spasm-vs-eyelid-twitch"
  element={<BlogPostEyeballSpasms />}
/>
<Route 
  path="blog/eye-twitching-anxiety"
  element={<BlogPostEyeTwitchingAnxiety />}
/>
<Route 
  path="blog/caffeine-and-eye-twitching"
  element={<BlogPostCaffeineEyeTwitching />}
/>
<Route 
  path="blog/left-vs-right-eye-twitching"
  element={<BlogPostLeftVsRightTwitching />}
/>
<Route 
  path="blog/eye-twitching-at-night"
  element={<BlogPostEyeTwitchingAtNight />}
/>
<Route 
  path="blog/vitamin-deficiency-eye-twitching"
  element={<BlogPostVitaminDeficiency />}
/>
<Route 
      path="blog/calf-twitching-after-exercise"
      element={<BlogPostCalfTwitchingExercise />}
    />
    <Route 
  path="blog/calf-muscle-twitching-at-night"
  element={<BlogPostCalfTwitchingNight />}
/>
<Route 
  path="blog/calf-twitching-anxiety"
  element={<BlogPostCalfTwitchingAnxiety />}
/>
<Route
            path="blog/calf-twitching-als"
            element={<BlogPostCalfTwitchingALS />}
          />
          <Route 
            path="blog/muscle-twitching-no-weakness"
            element={<BlogPostMuscleTwitchingNoWeakness />}
          />
          <Route 
            path="blog/calf-cramps-vs-twitching"
            element={<BlogPostCalfCrampsVsTwitching />}
          />
          <Route
path="blog/persistent-calf-twitching"
element={<BlogPostPersistentCalfTwitching />}
/>
<Route
  path="blog/leg-twitching-at-rest"
  element={<BlogPostLegTwitchingAtRest />}
/>
<Route
  path="blog/calf-twitching-dehydration"
  element={<BlogPostCalfTwitchingDehydration />}
/>
<Route
  path="blog/calf-twitching-magnesium"
  element={<BlogPostCalfTwitchingMagnesium />}
/>
<Route
  path="blog/tongue-twitching-bfs"
  element={<BlogPostTongueTwitching />}
/>
<Route
  path="blog/how-long-does-bfs-last"
  element={<BlogPostBFSTimeline />}
/>
<Route 
  path="blog/why-is-my-body-twitching-all-over"
  element={<BlogPostBodyTwitchingAllOver />}
/>
<Route 
  path="blog/muscle-twitching-in-sleep"
  element={<BlogPost_MuscleTwitchingInSleep />}
/>
<Route 
  path="blog/internal-vibrations-causes"
  element={<BlogPost_InternalVibrations />}
/>
<Route 
  path="blog/muscle-twitching-after-eating"
  element={<BlogPost_MuscleTwitchingAfterEating />}
/>
<Route 
  path="blog/muscle-twitching-one-spot-vs-all-over"
  element={<BlogPost_MuscleTwitchingOneSpotVsAllOver />}
/>

        </Route>
      </Routes>
    </Router>
  );
}

export default App;

